import React from 'react';
import ImageCaption from './ImageCaption';
import type { CarouselItem } from './Carousel';
import { useCarousel } from './Carousel';

interface CarouselCaptionProps {
  onCaptionChange: (image: CarouselItem, caption: string) => void;
}

const CarouselCaption = ({ onCaptionChange }: CarouselCaptionProps) => {
  const { images, currentIndex } = useCarousel();

  const image = images[currentIndex];

  if (!image) return null;

  return (
    <ImageCaption
      caption={image.caption ?? ''}
      onCaptionChange={(caption) => onCaptionChange(image, caption)}
    />
  );
};

export default CarouselCaption;
